import { Box, Card, CardContent, useMediaQuery } from "@mui/material";
import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import SimilarProductCard from "../Product/SimilarProductCard";
import { useHorizontalDragScroll } from "../../utils/useHorizontalDragScroll";

const SearchCard = ({ searchResults = [], currency, searchQuery }) => {
  const navigate = useNavigate();
  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const mediumScreen = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "lg")
  );
  const isTabletOrDesktop = useMediaQuery((theme) =>
    theme.breakpoints.up("sm")
  );

  const scrollRef = useHorizontalDragScroll();
  const cardRefs = useRef([]);

  const scrollLeft = () => {
    scrollRef.current?.scrollBy({ left: -300, behavior: "smooth" });
  };

  const scrollRight = () => {
    scrollRef.current?.scrollBy({ left: 300, behavior: "smooth" });
  };

  return (
    <Box
      ref={scrollRef}
      sx={{
        py: 2,
        px: smallScreen ? 2 : mediumScreen ? 0.5 : 2,
        pt: 0.5,
        display: isTabletOrDesktop ? "grid" : "flex",
        gridTemplateColumns: isTabletOrDesktop
          ? "repeat(auto-fit, minmax(320px, 1fr))"
          : "none",
        gap: 2,
        overflowX: smallScreen ? "auto" : "visible",
        position: "relative",
        "&::-webkit-scrollbar": smallScreen ? { display: "none" } : "unset",
      }}
    >
      {searchResults
        .filter((item) => {
          return (
            item?.products &&
            Array.isArray(item.products) &&
            item.products.length > 0
          );
        })
        .map((brand, index) => {
          return (
            <Card
              key={`search-card-${brand?.name || index}`}
              sx={{
                minWidth: smallScreen ? "75%" : "auto",
                maxWidth: isTabletOrDesktop ? "none" : "200px",
                borderRadius: "12px",
                display: "flex",
                flexDirection: "column",
                boxShadow: "-1px 5px 5px 5px rgba(3, 2, 2, 0.07)",
                flexShrink: 0,
                cursor: "pointer",
                overflow: "hidden",
              }}
            >
              <CardContent
                sx={{ p: 1, backgroundColor: "#fff" }}
                onClick={() => {
                  console.log(
                    "navigating to product this is console",
                    searchQuery
                  );
                  // navigate("/product", {
                  //   state: {
                  //     product: brand.products[0],
                  //     similarProducts: brand.products,
                  //     searchQuery: searchQuery,
                  //   },
                  // });
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#9AE0EB",
                    borderRadius: "4px",
                    padding: "5px 11px",
                    width: "fit-content",
                    mb: 1,
                  }}
                >
                  {brand.name}
                </Box>
              </CardContent>

              {/* Horizontal products */}
              <Box
                ref={(el) => (cardRefs.current[index] = el)}
                sx={{
                  overflowX: "auto",
                  overflowY: "hidden",
                  pb: 1,
                  "&::-webkit-scrollbar": {
                    height: "8px",
                    display: "block",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "10px",
                    "&:hover": {
                      backgroundColor: "#555",
                    },
                  },
                  "&::-webkit-scrollbar-corner": {
                    backgroundColor: "transparent",
                  },
                  scrollbarWidth: "thin",
                  scrollbarColor: "#888 #f1f1f1",
                }}
              >
                <SimilarProductCard
                  productData={brand.products}
                  noColor
                  oneLiner
                  index={index}
                  showAll={true}
                  searchQuery={searchQuery}
                />
              </Box>
            </Card>
          );
        })}
    </Box>
  );
};

export default SearchCard;
